"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const icons_1 = require("@dialogexe/cw-asset-provider/icons");
const marked_ts_1 = require("marked-ts");
class Content extends React.Component {
    constructor(props) {
        super(props);
        this.createMarkup = (content) => {
            return { __html: content };
        };
        marked_ts_1.Marked.setOptions({
            gfm: true,
            tables: true,
            breaks: false,
            pedantic: false,
            sanitize: false,
            smartLists: true,
            smartypants: false
        });
    }
    render() {
        const { content, links } = this.props;
        const markedContent = marked_ts_1.Marked.parse(content);
        return (React.createElement("div", { className: "Content" },
            links && links.length > 0 &&
                React.createElement("nav", { className: "menu is-hidden-desktop" },
                    React.createElement("div", { className: "input" },
                        React.createElement("select", { onChange: this.onNavChange.bind(this) },
                            React.createElement("option", { value: "" }, "Naviger til..."),
                            links.map((link, index) => (React.createElement("option", { key: index, value: index }, link.title)))),
                        React.createElement("i", null,
                            React.createElement("img", { src: icons_1.arrowheadDownIcon, alt: "" })))),
            React.createElement("div", { className: "content-body" },
                React.createElement("div", { className: "content-container", dangerouslySetInnerHTML: this.createMarkup(markedContent) }),
                links && links.length > 0 &&
                    React.createElement("nav", { className: "links is-visible-desktop" }, links.map((link, index) => (React.createElement("div", { className: "links", key: index },
                        React.createElement("a", { className: "button", href: link.url }, link.title))))))));
    }
    onNavChange(e) {
        const { links } = this.props;
        const index = e.target.value;
        if (index && typeof window !== 'undefined') {
            window.location.href = links[index].url;
        }
    }
}
exports.Content = Content;
exports.default = Content;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-content/Content.tsx